<template>
  <div
    class="ola-tab-pane"
    v-show="active"
  >
    <slot></slot>
  </div>
</template>

<script setup>
/**
 * TabPane 标签页内容组件
 * @component OlaTabPane
 * @description 配合 OlaTabs 使用的标签页内容容器
 */

defineOptions({
  name: 'OlaTabPane'
})

import { computed, inject, onMounted, onBeforeUnmount, reactive } from 'vue'

// ==================== Props ====================

const props = defineProps({
  /** 标签页名称，作为唯一标识符 */
  name: {
    type: String,
    required: true
  },
  /** 标签页标题 */
  label: {
    type: String,
    required: true
  },
  /** 是否禁用 */
  disabled: {
    type: Boolean,
    default: false
  },
  /** 是否使用 HTML 内容渲染标题 */
  useHtml: {
    type: Boolean,
    default: false
  }
})

// ==================== Inject ====================

/** 从父组件注入的 tabs 上下文 */
const tabs = inject('tabs')

// ==================== 计算属性 ====================

/** 当前标签页是否激活 */
const active = computed(() => tabs?.activeTab === props.name)

// ==================== Pane 配置对象 ====================

/** 传递给父组件的配置对象 */
const paneConfig = reactive({
  name: props.name,
  label: props.label,
  disabled: props.disabled,
  useHtml: props.useHtml
})

// ==================== 生命周期 ====================

onMounted(() => {
  tabs?.addPane(paneConfig)
})

onBeforeUnmount(() => {
  tabs?.removePane(paneConfig)
})
</script>

<style>
.ola-tab-pane {
  width: 100%;
}
</style>